<!-- =========================================================================================
    File Name: ItemListView.vue
    Description: Item Component - List VIew

========================================================================================== -->

<template>
  <vx-card>
    <div class="flex items-center justify-between">
      <div class="flex items-center">
        <img v-if="thumbnail" :src="thumbnail" width="125" class="rounded-lg hidden sm:block mr-5" draggable="false" />
        <div class="">
          <h2 class="font-bold mb-1">{{ name }}</h2>
          <p style="width: fit-content" :class="`flex items-center font-light rounded-full p-1 pl-2 pr-2 mt-4 ${completed ? 'bg-success' : 'bg-danger'}`">

            <!-- If completed is true -->
            <feather-icon class="pr-1" v-if="completed" icon="CheckCircleIcon" svgClasses="h-4 w-4" />

            <!-- If completed is false -->
            <feather-icon class="pr-1" v-else icon="XCircleIcon" svgClasses="h-4 w-4" />

            {{ completed ? 'Completed' : 'Not Completed' }}

          </p>
          <p :class="`font-light mt-2`">{{ min_score ? `Minimum Passing Score: ${min_score}%` : '' }}</p>
          <vs-button
            color="success"
            icon-pack="feather"
            icon="icon-play"
            class="mt-2 font-bold"
            type="gradient"
            @click="starterActive = true"
            >Start
          </vs-button>
        </div>
      </div>
      <radial-progress-bar
        :diameter="115"
        :completed-steps="terms_completed"
        :total-steps="terms_count"
        :animateSpeed="1100"
        timingFunc="ease"
        innerStrokeColor="#0000006b"
        startColor="#0cdc62"
        stopColor="#0cdc62"
        :strokeWidth="7"
        :innerStrokeWidth="7"
      >
        <h2 class="font-light">{{ percent }}%</h2>
      </radial-progress-bar>
    </div>
    <vs-popup :active.sync="starterActive" style-content="max-height: 600px" :title="`Start Assignment`">
      <div class="p-3">
        <div class="flex items-center justify-between mb-3">
          <div class="flex items-center">
            <img :alt="name" v-if="thumbnail" :src="thumbnail" width="75" class="rounded-lg mr-4" />
            <div>
              <h1 class="font-bold">{{ name }}</h1>
              <p style="width: fit-content" :class="`flex items-center font-light rounded-full p-1 pl-2 pr-2 mt-4 ${completed ? 'bg-success' : 'bg-danger'}`">

                <!-- If completed is true -->
                <feather-icon class="pr-1" v-if="completed" icon="CheckCircleIcon" svgClasses="h-4 w-4" />

                <!-- If completed is false -->
                <feather-icon class="pr-1" v-else icon="XCircleIcon" svgClasses="h-4 w-4" />

                {{ completed ? 'Completed' : 'Not Completed' }}

              </p>

            </div>
          </div>
          <radial-progress-bar
            :diameter="90"
            :completed-steps="percent"
            :total-steps="100"
            :animateSpeed="1100"
            timingFunc="ease"
            innerStrokeColor="#0000006b"
            startColor="#0cdc62"
            stopColor="#0cdc62"
            :strokeWidth="7"
            :innerStrokeWidth="7"
          >
            <h3 class="font-light">{{ percent }}%</h3>
          </radial-progress-bar>
        </div>

        <vs-button
          class="w-full font-bold mb-4"
          icon="icon-play"
          icon-pack="feather"
          color="primary"
          @click="
            $emit('generateQuiz');
            starterActive = false;
          "
          >Start Assignment
        </vs-button>

        <p class="font-semibold mb-1">Details</p>
        <div class="p-3 rounded-lg mb-4" style="background: rgba(0, 0, 0, 0.35)">
          <p>Range Start: {{ range_start }}</p>
          <p>Range End: {{ range_end }}</p>
          <p>Questions: {{ questions }}</p>
          <p class="capitalize">Mode: {{ mode }}</p>
          <p class="font-light">Time Limit: {{ timer ? `${timer.toString()} Minutes` : 'No Timer' }}</p>
        </div>

        <p class="font-semibold mb-1" v-if="description">Description</p>
        <div class="p-3 rounded-lg mb-4" v-if="description" style="background: rgba(0, 0, 0, 0.35)">
          <div class="instructions-show-details" v-html="description"></div>
        </div>

        <p class="font-semibold mb-1">Progress</p>
        <div class="p-3 rounded-lg mb-4" style="background: rgba(0, 0, 0, 0.35)">
          <span class="font-bold" v-if="!completed">
            {{ min_score ? `The mininum score to complete this assignment is ${min_score}%` : '' }}</span
          >
          <span class="font-bold" v-else>You have completed the assignment!</span>
        </div>
      </div>
    </vs-popup>
  </vx-card>
</template>

<script>
import RadialProgressBar from 'vue-radial-progress'

export default {
  data () {
    return {
      starterActive: false
    }
  },
  computed: {
    activeCourseInfo () {
      return this.$store.state.AppActiveCourse
    }
  },
  methods: {},
  props: {
    id: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: false
    },
    thumbnail: {
      type: String,
      default: null,
      required: false
    },
    percent: {
      type: Number,
      default: 0,
      required: false
    },
    completed: {
      type: Boolean,
      default: false,
      required: false
    },
    range_start: {
      type: Number,
      default: 0,
      required: false
    },
    range_end: {
      type: Number,
      default: 0,
      required: false
    },
    questions: {
      type: Number,
      default: 0,
      required: false
    },
    timer: {
      type: Number,
      default: 0,
      required: false
    },
    mode: {
      type: String,
      required: false
    },
    terms_completed: {
      type: Number,
      default: 0,
      required: false
    },
    terms_count: {
      type: Number,
      default: 0,
      required: false
    },
    min_score: {
      type: Number,
      default: 0,
      required: false
    }
  },
  components: {
    RadialProgressBar
  }
}
</script>
